var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var UserHousingTypeQuestion_1;
/**
 * [CLAIMS_CONTEXT]
 * purpose: Question step asking the user to confirm or select their housing type (apartment or house).
 * touches: qualification
 * invariants: saves housing type on the contract (contracts.housing_type_id), not the claim
 * inputs: contract.housingType getter (slug from selected contract)
 * outputs: contract.housingType via updateHousingType PUT on the contract IRI
 * see: frontend/src/declaration/stepConfigurations.ts, backend/src/Entity/Contract.php
 */
import Component from 'vue-class-component';
import { namespace } from 'vuex-class';
import { UiButton, UiRadio } from '@claims-ia/design-system';
import QuestionPanel from '@declaration/components/UI/QuestionPanel.vue';
import { QuestionComponent, QuestionProps } from '@declaration/question';
import { HousingTypeSlug } from '@shared/types/api/contract';
const contract = namespace('contract');
const claim = namespace('claim');
let UserHousingTypeQuestion = UserHousingTypeQuestion_1 = class UserHousingTypeQuestion extends QuestionComponent {
    constructor() {
        super(...arguments);
        this.isUpdatingHousingType = false;
    }
    async created() {
        await this.fetchHousingTypesIfNeeded();
    }
    get housingTypeChoices() {
        return UserHousingTypeQuestion_1.KNOWN_SLUGS.map((slug) => {
            var _a;
            return ({
                value: slug,
                label: this.$tc(`claim.qualification.user_housing_type.slug.${slug}`),
                imageSrc: (_a = UserHousingTypeQuestion_1.HOUSING_TYPE_IMAGES[slug]) !== null && _a !== void 0 ? _a : '',
            });
        });
    }
    get selectedHousingTypeSlug() {
        var _a;
        return (_a = this.contractHousingType) !== null && _a !== void 0 ? _a : null;
    }
    async onHousingTypeInput(slug) {
        var _a;
        if (this.isUpdatingHousingType)
            return;
        await this.fetchHousingTypesIfNeeded();
        const housingType = ((_a = this.housingTypes) !== null && _a !== void 0 ? _a : []).find((ht) => ht.slug === slug);
        if (!housingType)
            return;
        this.isUpdatingHousingType = true;
        try {
            await this.updateHousingType({
                id: housingType.id,
                slug: housingType.slug,
            });
        }
        finally {
            this.isUpdatingHousingType = false;
        }
    }
    get panelTitle() {
        return this.$tc('claim.qualification.user_housing_type.title');
    }
    get sidebarTitle() {
        return this.$tc('claim.qualification.user_housing_type.sidebar_title');
    }
    get canValidate() {
        return (this.contractHousingType === HousingTypeSlug.Apartment ||
            this.contractHousingType === HousingTypeSlug.House);
    }
    validate() {
        if (!this.canValidate)
            return;
        this.updateAndSaveClaim({ claimPayload: {}, step: this.step });
    }
    get answer() {
        if (this.contractHousingType === HousingTypeSlug.Apartment ||
            this.contractHousingType === HousingTypeSlug.House) {
            return this.$tc(`claim.qualification.user_housing_type.answer.${this.contractHousingType}`);
        }
        return null;
    }
};
UserHousingTypeQuestion.HOUSING_TYPE_IMAGES = {
    [HousingTypeSlug.Apartment]: require('@declaration/assets/images/housing-type/appartment.svg'),
    [HousingTypeSlug.House]: require('@declaration/assets/images/housing-type/house.svg'),
};
UserHousingTypeQuestion.KNOWN_SLUGS = [HousingTypeSlug.Apartment, HousingTypeSlug.House];
__decorate([
    contract.State('housingTypes')
], UserHousingTypeQuestion.prototype, "housingTypes", void 0);
__decorate([
    contract.Action('fetchHousingTypesIfNeeded')
], UserHousingTypeQuestion.prototype, "fetchHousingTypesIfNeeded", void 0);
__decorate([
    contract.Action('updateHousingType')
], UserHousingTypeQuestion.prototype, "updateHousingType", void 0);
__decorate([
    contract.Getter('housingType')
], UserHousingTypeQuestion.prototype, "contractHousingType", void 0);
__decorate([
    claim.State('isUpdatingClaim')
], UserHousingTypeQuestion.prototype, "isUpdatingClaim", void 0);
__decorate([
    claim.Action('updateAndSaveClaim')
], UserHousingTypeQuestion.prototype, "updateAndSaveClaim", void 0);
UserHousingTypeQuestion = UserHousingTypeQuestion_1 = __decorate([
    Component({
        components: { QuestionPanel, UiRadio, UiButton },
        props: QuestionProps,
    })
], UserHousingTypeQuestion);
export default UserHousingTypeQuestion;
